import {
  addPersistingQueryParamsToPath,
  ERROR_REDIRECT_EXCLUDE_PARAMS,
} from './urlHelper';

type PathKey = 'main' | 'app' | 'ikeaapp' | 'alt';

const SERVICE_UNAVAILABLE_PATH: Record<PathKey, string> = {
  main: `/service-unavailable/`,
  app: `/app/service-unavailable/`,
  ikeaapp: `/ikeaapp/service-unavailable/`,
  alt: `/alt/service-unavailable/`,
};

const getPathKeyFromPathname = (pathname: string): PathKey => {
  const pathParts = pathname.split('/').filter(Boolean);
  const indexOfView = pathParts.indexOf('appointment') + 1;
  if (pathParts[indexOfView] === 'app') {
    return 'app';
  } else if (pathParts[indexOfView] === 'ikeaapp') {
    return 'ikeaapp';
  } else if (pathParts[indexOfView] === 'alt') {
    return 'alt';
  }
  return 'main';
};

const getRedirectPath = (): string => {
  const pathname = window.location.pathname;
  const pathKey = getPathKeyFromPathname(pathname);
  return SERVICE_UNAVAILABLE_PATH[pathKey];
};

export const getServiceUnavailablePath = (withQueryParams = false): string => {
  const path = getRedirectPath();
  const pathWithQueryParams = withQueryParams
    ? addPersistingQueryParamsToPath(path, {
        exclude: ERROR_REDIRECT_EXCLUDE_PARAMS,
      })
    : path;
  return pathWithQueryParams;
};
